import Cookies from "js-cookie";

const logout = ({ Auth }) => {
  Cookies.remove("sambauser");
  Auth.setLoggedIn(false);
};

export default logout;
